import React, { useState } from 'react';
import { FormControl, InputLabel, MenuItem, Select, Box, ListItemText, SelectChangeEvent, styled } from '@mui/material';
import { Button } from 'reactstrap';
import { useTranslation } from 'react-i18next';

import { setCurrentClientBody } from '../Slice/clientsSlice';

import { useAppDispatch, useAppSelector } from 'slices';
import { ClientsDisplayBodys } from 'components/ClientTable/ClientsDisplayBodys';
import useClientCompanyData from 'hooks/Clients/useClientCompanyData';
import ModalAddSwitch from 'pages/ClientDashboard/Modals/ModalAddSwitch';

const CustomSelect = styled(Select)({
  '&.MuiInputBase-root': {
    backgroundColor: 'transparent',
    boxShadow: 'none',
    borderColor: 'red',
  },
  '& .MuiSelect-select': {
    padding: '10px 12px',
    paddingRight: '24px',
  },
  '& .MuiOutlinedInput-notchedOutline': {
    border: '1px solid #E0E0E0',
  },
});

interface Props {
  refetch: () => void;
  allObjects: number | null;
}

const ClientsHeader: React.FC<Props> = ({ refetch, allObjects }) => {
  const dispatch = useAppDispatch();
  const { t } = useTranslation();
  const { data: serviceProviderData, isLoading } = useClientCompanyData();
  const [isManageModalOpen, setIsManageModalOpen] = useState(false);
  const { currentClientBody } = useAppSelector(state => state.ClientsBody);
  const tables: string[] = Object.values(ClientsDisplayBodys).slice(0, 3);
  const handleChange = (event: SelectChangeEvent<unknown>) => {
    dispatch(setCurrentClientBody(event.target.value as ClientsDisplayBodys));
  };

  return (
    <>
      <div className="d-flex flex-column flex-md-row gap-1 gap-lg-0 align-items-center justify-content-between  bg-white pt-2 pb-2 px-3">
        <div className="d-flex flex-row gap-2 align-items-end justify-content-center text-center">
          <div className="">
            <h6 className="mb-0 mt-2 fs-18 text-start text-wrap">{t('ClientsDashboard.dashboard.clients')}</h6>
            <p className="text-muted mb-1 fs-14 text-start">{currentClientBody}</p>
          </div>
          {allObjects !== null && (
            <p className="text-muted mb-1 fs-14 text-start ps-2">
              {t('ClientsDashboard.dashboard.allSites')}: {allObjects}
            </p>
          )}
          {/* <div className="d-none d-lg-flex align-items-center align-items-lg-start h4 mb-0 fw-bold gap-2 ">
            {currentClientBody}
            </div> */}
        </div>

        <div className="d-flex justify-content-center flex-row flex-lg-row">
          <div className="d-flex">
            {!isLoading && serviceProviderData?.is_pest_company && serviceProviderData?.is_active && (
              <Button
                id="add-action-btn"
                className="btn btn-ghost-success m-1"
                onClick={e => {
                  e.currentTarget.blur();
                  setIsManageModalOpen(true);
                }}
              >
                <i className="ri-add-line align-bottom me-1" />
                {t('ClientsDashboard.dashboard.add-client')}
              </Button>
            )}
          </div>
          <div className="d-flex">
            <FormControl sx={{ minWidth: 120 }} style={{ zIndex: 14 }}>
              <InputLabel
                style={{ fontFamily: 'Poppins, sans-serif' }}
                id="demo-simple-select-standard-label"
                sx={{ fontFamily: 'Poppins, sans-serif' }}
              >
                {t('ClientsDashboard.dashboard.clientsView')}
              </InputLabel>
              <CustomSelect
                value={currentClientBody}
                onChange={handleChange}
                label={t('ClientsDashboard.dashboard.clientsView')}
                id="demo-simple-select-filled"
                sx={{
                  width: 200,
                  fontFamily: 'Poppins, sans-serif',
                  '&:hover .MuiOutlinedInput-notchedOutline': {
                    borderColor: 'var(--vz-purple)',
                  },

                  '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                    borderColor: 'var(--vz-purple)',
                  },
                }}
                renderValue={selected => {
                  if (typeof selected !== 'string') return null; // Ensure type safety

                  return (
                    <Box display="flex" alignItems="center" justifyContent="start">
                      <ListItemText primary={selected} />
                    </Box>
                  );
                }}
              >
                {tables.map(tableName => (
                  <MenuItem key={tableName} value={tableName} sx={{ fontFamily: 'Poppins, sans-serif' }}>
                    <ListItemText primary={tableName} />
                  </MenuItem>
                ))}
              </CustomSelect>
            </FormControl>
          </div>
        </div>
      </div>
      <ModalAddSwitch
        isOpen={isManageModalOpen}
        onClose={() => setIsManageModalOpen(false)}
        refetchClients={refetch}
        target="add-action-btn"
      />
    </>
  );
};

export default ClientsHeader;
